// @flow

export default {
  wizard: {
    next: 'Next',
    back: 'Back',
    skip: 'Skip',
    sort: 'Sort',
    sorting: {
      'utility:desc': 'Best result',
      'price:asc': 'Price ascending',
      'price:desc': 'Price descending',
      'created_at:desc': 'Newest',
      'customer_rating:desc': 'Customer Rating'
    },
    clickToAddFiles: 'Click to add your files or drop them here.',
    searchFor: 'Search for ...',
    noSearchResults: 'Unfortunately we have not found any suitable options. Please search again.',
    loadMoreAnswerOptions: 'No suitable option here? Display all options.',
    noRecommendationDescription: 'Oh no, unfortunately we could not find any products that fit your needs.',
    noRecommendationDescription2: 'Please restart the product advisor.',
    noRecommendationRestartButtonTitle: 'Restart',
    noRecommendationCloseButtonTitle: 'Close',
    removeFile: 'Remove file'
  },
  chatbot: {
    selectAll: 'Select all',
    none: 'None',
    confirmButton: 'Confirm',
    customerServiceInputPlaceholder: 'Write a message ...',
    you: 'You',
    restart: 'Start again',
    close: 'Close',
    send: 'Send',
    supportChat: 'Support Chat',
    honeypot: 'Please leave this field blank',
    scrollToTheLatestMessage: 'Scroll to the latest message',
    removeFile: 'Remove file'
  },
  product: {
    loadMore: 'Load more products',
    badgeTitle: 'Our recommendation',
    ctaButtonTitle: 'Discover product',
    matchingPanelTitle: 'Tailored to your needs',
    bestFit: 'Best fit',
    bestPrice: 'Best price',
    bestFitForPrice: 'Best fit-for-price',
    addToCartError: 'Add to cart was not successful. Please try again',
    addRoutineToCart: 'Add routine to cart',
    explanationHeader: 'More product information:',
    emptyRoutineItem: 'Unfortunately there is no fitting product in that category that matches your preferences.'
  },
  tabBar: {
    chat: 'Chat',
    productAdvisor: 'Product advisor'
  },
  recommender: {
    answerOptionLeadsToNoRecommendation: 'Unfortunately, this option would not lead to any desired product. You can change your preference in previous steps to enable the option.'
  }
}
